import { useTranslation } from '@common';
import { Icons } from '../../icons';
import styles from './style.module.less';
import type { ReactElement } from 'react';

interface EmptyProps {
  color?: string;
}

export function Empty(props: EmptyProps): ReactElement {
  const [t] = useTranslation();
  const { color = 'inherit' } = props;

  return (
    <div className={styles.emptyContainer}>
      <Icons name='EmptyIcon' style={{ color }} />
      <span className={styles.emptyText}>{t('暂无数据')}</span>
    </div>
  );
}
